import { useTranslation } from 'react-i18next'

/**
 * Skip-to-content link — first focusable element in the document.
 * Visually hidden until focused, at which point it becomes a visible
 * top-left chip that jumps focus to `#main-content` (rendered by
 * `PageLayout`).
 *
 * Addresses the accessibility gap flagged in `analysis/docs/site_analysis.md`:
 * the original hsacosmetics.com had no skip-link.
 */
export function SkipToContent() {
  const { t, i18n } = useTranslation('common')
  // Guard against i18next namespace-not-loaded warnings on initial render.
  const label = i18n.exists('aria.skipToContent')
    ? t('aria.skipToContent')
    : 'Vai al contenuto principale'
  return (
    <a
      href="#main-content"
      className={[
        'sr-only focus:not-sr-only',
        'focus:fixed focus:top-3 focus:left-3 focus:z-[100]',
        'focus:px-4 focus:py-2.5',
        'focus:bg-[color:var(--color-accent)] focus:text-[color:var(--color-on-accent)]',
        'focus:rounded-[var(--radius-md)] focus:shadow-[var(--shadow-md)]',
        'focus:text-[0.78rem] focus:uppercase focus:tracking-[0.16em] focus:font-medium',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-[color:var(--color-highlight)]',
      ].join(' ')}
    >
      {label}
    </a>
  )
}
